import { render, staticRenderFns } from "./ChoosePhone.vue?vue&type=template&id=06d003fc&"
import script from "./ChoosePhone.vue?vue&type=script&lang=js&"
export * from "./ChoosePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports